import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subscriber } from "rxjs";
import { environment } from "src/environments/environment";
import { IGroup } from "src/models/user/group.interface";
import { ICompaniesListResponse, IMetaDataResponse } from "src/models/api-response/util-list-response.inteface";
import { IDivisionListResponse } from "src/models/api-response/util-list-response.inteface";
import { ISectionListResponse } from "src/models/api-response/util-list-response.inteface";
import { IDeviceTypesListResponse } from "src/models/api-response/util-list-response.inteface";
import { TokenStorageService } from "./token-storage.service";
import { AuthService } from "./auth.service";
import { UserService } from "./user.service";
import { CreatePhoneReportData, DivisionDetailsPayload, Office, OfficeCreate, OfficeRecord, PhoneDesk, PhoneDeskCreate, PhoneListDTO, PhoneReportData } from "src/models/user/user-info.interface";

@Injectable({
    providedIn: 'root'
  })
  export class UtilService {
    private token: string = "";
    private userName: string = "";
    private loggedInObservable: Observable<boolean>;
    private subscribers: Array<Subscriber<boolean>>;

    constructor(private http: HttpClient, private tokenStorageService: TokenStorageService, private authService: AuthService, private userService: UserService)
    {
      this.loggedInObservable = this.authService.isLoggedIn();
      this.subscribers = [];

      this.loggedInObservable.subscribe(b => {
        if (b) {
            this.token = this.tokenStorageService.getToken();
            this.userName = this.tokenStorageService.getUserName();
        }
      });
    }

    public assureToken() : Observable<boolean> {
      return new Observable<boolean>((s) => {
        this.loggedInObservable.subscribe(b => {
          if (b && this.token) {
            this.checkIsAdmin(b);
            s.next(b);
          }
          else {
            setTimeout(() => {
              if (b && this.token) {
                s.next(b);
              }
            }, 1000);
          }
        });
      });
    }

    public checkIsAdmin(b: boolean) {

      this.userService.getUserInfoByLoginName(this.userName).subscribe( res => {
        if(res.messageType != "OK"){
          return;
        }

        // triggers admin observable
        // this.isAdmin(this.tokenStorageService.getUserName());
        this.userService.GetUserRoles(Number(this.tokenStorageService.getUserInfoId()))
        .subscribe(usr => {
          this.notifySubscribers(usr.isAdmin);
        });
      });

    }

    public getIsAdminObservable() : Observable<boolean> {
      return new Observable<boolean>((s) => {
        this.subscribers.push(s);
      });
    }

    public notifySubscribers(isAdmin: boolean) {
      this.subscribers.forEach(s => {
        s.next(isAdmin);
      });
    }

    // public isAdmin(userName: string) : boolean {

    //   let userIsAdmin = false;
    //   return this.userService.isAdmin(userName)
    //     .subscribe(usrAdmin => {
    //       userIsAdmin = usrAdmin;
    //       let msg = "User is " + (userIsAdmin ? "" : "not ") + "an Admin";
    //       console.log(msg);
    //       this.notifySubscribers(userIsAdmin);
    //       return userIsAdmin;
    //     });


    // }

    /*Get Methods*/
    public getSectionsList(divisionID: number): Observable<ISectionListResponse>{
        const headers = new HttpHeaders({
        'Authorization' : this.token,
        'UserName' : this.userName,
        'AuthenticationToken': environment.AuthenticationToken
        })
        let params = new HttpParams().append('DivisionID', divisionID);
        return this.http.get<ISectionListResponse>(environment.apiUrl + '/GetSections', {'headers' : headers, 'params': params });
    }

    public getDivisionsList(): Observable<IDivisionListResponse>{
        const headers = new HttpHeaders({
        'Authorization' : this.token,
        'UserName' : this.userName,
        'AuthenticationToken': environment.AuthenticationToken
        })
        return this.http.get<IDivisionListResponse>(environment.apiUrl + '/GetDivisions', {'headers' : headers});
    }

        public getAllDivisionsList(): Observable<IDivisionListResponse>{
        const headers = new HttpHeaders({
        'Authorization' : this.token,
        'UserName' : this.userName,
        'AuthenticationToken': environment.AuthenticationToken
        })
        return this.http.get<IDivisionListResponse>(environment.apiUrl + '/GetAllDivisions', {'headers' : headers});
    }

    public getMetaData(keyWord:string,groupkey:string): Observable<IMetaDataResponse[]>{
        const headers = new HttpHeaders({
        'Authorization' : this.token,
        'UserName' : this.userName,
        'AuthenticationToken': environment.AuthenticationToken
        })
        let params = new HttpParams().append('keyWord', keyWord).append('groupkey',groupkey);
        return this.http.get<IMetaDataResponse[]>(environment.apiUrl + '/GetADMetaData', {'headers' : headers, 'params': params });
    }

    public GetPhoneListReport(): Observable<PhoneListDTO[]>{
        const headers = new HttpHeaders({
        'Authorization' : this.token,
        'UserName' : this.userName,
        'AuthenticationToken': environment.AuthenticationToken
        })
        let params = new HttpParams();
        return this.http.get<PhoneListDTO[]>(environment.apiUrl + '/GetPhoneListReport', {'headers' : headers, 'params': params });
    }

  GetAllPhoneWithDesks(): Observable<OfficeRecord[]> {
      const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    return this.http.get<OfficeRecord[]>(environment.apiUrl + '/GetAllPhoneWithDesks' , {'headers' : authHeader});
  }

    
    public SaveDivisonPhoneListDeatils(divisionMetadata: DivisionDetailsPayload): Observable<string> {
      const authHeader = new HttpHeaders({
        'Authorization': this.token,
        'AuthenticationToken': environment.AuthenticationToken,
        'UserName': this.userName
      });
      
      return this.http.post(environment.apiUrl + '/SaveDivisonPhoneListDeatils', divisionMetadata, { 'headers': authHeader, responseType: "text" });
    }

      public LoadDivisionPhoneListDetails(divisionId: string, sectionId : string): Observable<DivisionDetailsPayload> {
        const authHeader = new HttpHeaders({
          'Authorization': this.token,
          'AuthenticationToken': environment.AuthenticationToken,
          'UserName': this.userName
        });
        let LoggedInUserId = Number(this.tokenStorageService.getUserInfoId());
        let params = new HttpParams().append('divisionId', divisionId);
        params = params.append('sectionId', sectionId);
        //console.log("tracking loggedinuserid");
        return this.http.get<DivisionDetailsPayload>(environment.apiUrl + '/LoadDivisionPhoneListDetails', { 'headers': authHeader, 'params': params });
      }

    public getCompaniesList(): Observable<ICompaniesListResponse>{
        const headers = new HttpHeaders({
        'Authorization' : this.token,
        'UserName' : this.userName,
        'AuthenticationToken': environment.AuthenticationToken
        })
        return this.http.get<ICompaniesListResponse>(environment.apiUrl + '/GetCompanies', {'headers' : headers});
    }

    public getUserDeviceTypeList(): Observable<IDeviceTypesListResponse>{
        const headers = new HttpHeaders({
        'Authorization' : this.token,
        'UserName' : this.userName,
        'AuthenticationToken': environment.AuthenticationToken
        })
        return this.http.get<IDeviceTypesListResponse>(environment.apiUrl + '/GetDeviceTypes', {'headers' : headers});
    }

    GetPhoneListOtherData(): Observable<PhoneReportData[]> {
      const headers = new HttpHeaders({
        'Authorization' : this.token,
        'UserName' : this.userName,
        'AuthenticationToken': environment.AuthenticationToken
        })
      return this.http.get<PhoneReportData[]>(environment.apiUrl + '/GetPhoneListOtherData', {'headers' : headers});
    }

    GetPhoneListOtherDataById(id: number): Observable<PhoneReportData> {
       const headers = new HttpHeaders({
        'Authorization' : this.token,
        'UserName' : this.userName,
        'AuthenticationToken': environment.AuthenticationToken
        })
         let params = new HttpParams().append('id', id);
       return this.http.get<PhoneReportData>(environment.apiUrl + '/GetPhoneListOtherDataById', { 'headers': headers, 'params': params });
    }

    SavePhoneListOtherData(dto: CreatePhoneReportData): Observable<PhoneReportData> {
      const headers = new HttpHeaders({
        'Authorization' : this.token,
        'UserName' : this.userName,
        'AuthenticationToken': environment.AuthenticationToken,
        'Content-Type': 'application/json'
        })
      return this.http.post<PhoneReportData>(environment.apiUrl + '/SavePhoneListOtherData', dto, { 'headers': headers});
    }

    UpdatePhoneListOtherData(id: number, data: PhoneReportData): Observable<void> {
      const headers = new HttpHeaders({
        'Authorization' : this.token,
        'UserName' : this.userName,
        'AuthenticationToken': environment.AuthenticationToken
        })
      return this.http.put<void>(environment.apiUrl + '/UpdatePhoneListOtherData', data, { 'headers': headers});
    }

   
     public DeletePhoneListOtherData(id: number): Observable<string> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    return this.http.post(environment.apiUrl + '/DeletePhoneListOtherData?id=' + id, null, { 'headers': authHeader, responseType: "text" });
  }
   getOffices(): Observable<Office[]> {
     const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    return this.http.get<Office[]>(environment.apiUrl + '/GetPhoneDeskOfficeData', {'headers' : authHeader});
  }

  createOffice(dto: OfficeCreate): Observable<Office> {
     const headers = new HttpHeaders({
        'Authorization' : this.token,
        'UserName' : this.userName,
        'AuthenticationToken': environment.AuthenticationToken,
        'Content-Type': 'application/json'
        })
      return this.http.post<Office>(environment.apiUrl + '/SavePhoneDeskOfficeData', dto, { 'headers': headers});
  }

  updateOffice(id: number, dto: OfficeCreate): Observable<void> {
      const headers = new HttpHeaders({
        'Authorization' : this.token,
        'UserName' : this.userName,
        'AuthenticationToken': environment.AuthenticationToken
        })
      return this.http.put<void>(environment.apiUrl + '/UpdatePhoneDeskOfficeData?id=' + id, dto, { 'headers': headers});
  }

  deleteOffice(id: number): Observable<string> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    return this.http.post(environment.apiUrl + '/DeletePhoneDeskOfficeData?id=' + id, null, { 'headers': authHeader, responseType: "text" });
    
  }

  // ----- PhoneDesk -----
  getPhoneDesks(officeId: number): Observable<PhoneDesk[]> {
      const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    return this.http.get<PhoneDesk[]>(environment.apiUrl + '/GetPhoneDeskDataByOffice?officeId=' + officeId, {'headers' : authHeader});
  }

  createPhoneDesk(officeId: number, dto: PhoneDeskCreate): Observable<PhoneDesk> {
 const headers = new HttpHeaders({
        'Authorization' : this.token,
        'UserName' : this.userName,
        'AuthenticationToken': environment.AuthenticationToken,
        'Content-Type': 'application/json'
        })
      return this.http.post<PhoneDesk>(environment.apiUrl + '/SavePhoneDeskDataByOffice?officeId=' + officeId, dto, { 'headers': headers});
  }

  updatePhoneDesk(id: number, dto: PhoneDeskCreate): Observable<void> {
      const headers = new HttpHeaders({
        'Authorization' : this.token,
        'UserName' : this.userName,
        'AuthenticationToken': environment.AuthenticationToken
        })
      return this.http.put<void>(environment.apiUrl + '/UpdatePhoneDeskDataByOffice?id=' + id, dto, { 'headers': headers});
  }

  deletePhoneDesk(id: number): Observable<string> {
     const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
     return this.http.post(environment.apiUrl + '/DeletePhoneDeskDataByOffice?id=' + id, null, { 'headers': authHeader, responseType: "text" });
    
  }

    /*Set Methods*/
    public setDivisionList(res: IDivisionListResponse): IGroup[]{
      let divi: IGroup[] = [];
      if(res.divisions) {
        res.divisions!.forEach(division => {
          if(division.id && division.name){
            divi.push({ID: division.id, Name: division.name});
          }
        });
        if(divi.length > 0){
            divi.sort((a,b) => a.Name > b.Name ? 1 : -1);
        }
      }
      return divi;
    }

    public setSectionList(SectionList: ISectionListResponse): IGroup[]{
      let sec: IGroup[] = [];
      SectionList.sections!.forEach(section => {
        if(section.id != null  && section.sectionName != null){
          sec.push({ Name: section.sectionName, ID: section.id});
        }
      });
      if(sec.length > 0){
          sec.sort((a,b) => a.Name > b.Name ? 1 : -1);
      }
      return sec;
    }

    public setCompaniesList(companies: ICompaniesListResponse): IGroup[]{
      let sec: IGroup[] = [];
      companies.companiesList.forEach(company => {
        if(company.id && company.name){
          sec.push({ID: company.id, Name: company.name});
        }
      });
      if(sec.length > 0){
          sec.sort((a,b) => a.Name > b.Name ? 1 : -1);
      }
      return sec;
    }

    public setDeviceTypesList(devices: IDeviceTypesListResponse): IGroup[]{
        let sec: IGroup[] = [];
        devices.deviceTypes.forEach(device => {
          if(device.deviceTypeID && device.deviceTypeName){
            sec.push({ID: device.deviceTypeID, Name: device.deviceTypeName});
          }
        });
        if(sec.length > 0){
            sec.sort((a,b) => a.Name > b.Name ? 1 : -1);
        }

        return sec;
      }

        
  }
